import { Component } from '@angular/core';
import { PageContent } from "../../../shared/page-content/page-content.component";
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-contact-success',
  imports: [PageContent, RouterLink, NgOptimizedImage],
  templateUrl: './contact-success.component.html',
  styleUrl: './contact-success.component.scss',
})
export class ContactSuccess {

}
